
// constants as defined in RevoXef’s App\Models\Orders\OrderContent
const NORMAL = 1
const MENU = 2

export default {
  NORMAL,
  MENU,
}
